import {
  Box,
  Paper,
  Stack,
  Typography,

} from '@mui/material';
import Construction from '@mui/icons-material/Construction';

function Placeholder({ title, description, features, benefits }) {
  return (
    <Box>
      <Typography variant='h4' fontWeight={700} sx={{ mb: 1 }}>
        {title}
      </Typography>

      <Paper
        sx={{
          px: 6,
          py: 3,
          // textAlign: 'center',
          backgroundColor: 'background.paper'
        }}
      >
        <Stack direction='row' spacing={1} alignItems='center' sx={{ mb: 1 }}>
        </Stack>
        {/* <Box sx={{ mb: 1, textAlign: 'center' }}>
          <Construction sx={{ fontSize: 64, }} />
          <Typography variant='body1'>Coming Soon</Typography>
        </Box> */}
        {/* Description */}
        <Typography variant='body1' >
          {description}
        </Typography>
        {/* Features */}
        <Typography variant='body1' mt={1}>
          {benefits !== '' ? 'Key capabilities will include:' : 'Future capabilities may include:'}
        </Typography>
        <Typography component="ul">
          {features.map((feature) => (
            <Typography component='li'>{feature}</Typography>
          ))}
        </Typography>

        {/* Benefits */}
        <Typography variant='body1' mt={1}>
          {benefits}
        </Typography>

        <Box sx={{ mt: 3, textAlign: 'center' }}>
          <Construction sx={{ fontSize: 64 }} />
          <Typography variant='body1'>Coming Soon</Typography>
          <Typography variant='body2'>This section is under development</Typography>
        </Box>

      </Paper>
    </Box>
  )
}

export default Placeholder;